(function () {
  'use strict';

  var html = document.documentElement;
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var THEME_RETURN_MS = 500;
  var CODE_MAX = 255;

  var warsawFormat = null;

  function warsawOffset(t) {
    if (!warsawFormat) {
      warsawFormat = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Warsaw', hourCycle: 'h23', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    }
    var p = {};
    warsawFormat.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - t;
  }

  function warsawEpoch(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value || '');
    if (!m) return NaN;
    var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    return wall - warsawOffset(wall - warsawOffset(wall));
  }

  function promoText(ms, el) {
    var sec = Math.floor(ms / 1000);
    var days = Math.floor(sec / 86400);
    var clock = pad(Math.floor((sec % 86400) / 3600)) + ':' + pad(Math.floor((sec % 3600) / 60)) + ':' + pad(sec % 60);
    if (days < 1) return clock;
    var label = (days === 1 ? el.getAttribute('data-day-one') : el.getAttribute('data-day-other')).replace('[count]', days);
    return label + ' ' + clock;
  }

  function updatePromo(drawer, state) {
    clearInterval(state.promoTimer);
    var el = drawer.querySelector('[data-kosz-promo]');
    if (!el) return;
    var end = warsawEpoch(el.getAttribute('data-end'));
    var time = el.querySelector('[data-kosz-promo-time]');
    function tick() {
      var left = end - Date.now();
      if (isNaN(end) || left <= 0) {
        clearInterval(state.promoTimer);
        if (el.hidden) return;
        el.classList.add('is-ending');
        setTimeout(function () { el.hidden = true; }, reducedMotion() ? 0 : cssMs(el, '--kosz-dur-micro', 160));
        return;
      }
      var appearing = el.hidden;
      time.textContent = promoText(left, el);
      el.hidden = false;
      if (appearing && drawer.classList.contains('drawer--is-open')) announce(drawer, el.textContent);
    }
    tick();
    if (!el.hidden && drawer.classList.contains('drawer--is-open')) {
      state.promoTimer = setInterval(tick, 1000);
    }
  }

  function pickQuote(drawer, state) {
    var quotes = drawer.querySelectorAll('[data-kosz-quote]');
    if (quotes.length < 2) return;
    var next = state.quote;
    while (next === state.quote) next = Math.floor(Math.random() * quotes.length);
    state.quote = next;
    quotes.forEach(function (q, i) { q.hidden = i !== next; });
  }

  function announce(drawer, text) {
    var live = drawer.querySelector('[data-kosz-live]');
    text = (text || '').replace(/\s+/g, ' ').trim();
    if (!live || !text) return;
    live.textContent = '';
    requestAnimationFrame(function () { live.textContent = text; });
  }

  function usable(el) {
    return !!el && el.isConnected && !el.disabled && el.getClientRects().length > 0;
  }

  function focusables(drawer) {
    return [].filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.tabIndex >= 0 && usable(el) && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function bindFocus(drawer, state) {
    var form = drawer.querySelector('form');
    var lastOutside = null;

    function remember(evt) {
      var el = evt.target && evt.target.closest && evt.target.closest(FOCUSABLE);
      if (el && !drawer.contains(el)) lastOutside = el;
    }
    document.addEventListener('focusin', remember);
    document.addEventListener('click', remember, true);

    state.rememberOpener = function () {
      state.opener = lastOutside;
    };

    state.returnFocus = function () {
      setTimeout(function () {
        var opener = state.opener;
        var active = document.activeElement;
        if (drawer.classList.contains('drawer--is-open') || !usable(opener) || active === opener) return;
        if (!active || active === document.body || drawer.contains(active) || active.matches('.js-drawer-open-cart')) {
          opener.focus();
        }
      }, THEME_RETURN_MS + 20);
    };

    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Tab' || !drawer.classList.contains('drawer--is-open') || html.classList.contains('kosz-chat')) return;
      var list = focusables(drawer);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;
      var inside = drawer.contains(active);
      var atRoot = active === drawer || active === form;
      if (evt.shiftKey && (!inside || atRoot || active === first)) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && (!inside || active === last)) {
        evt.preventDefault();
        first.focus();
      }
    }, true);
  }

  function cssMs(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    var n = parseFloat(v);
    if (isNaN(n)) return fallback;
    return /ms$/.test(v) ? n : n * 1000;
  }

  function watchOpen(drawer, state) {
    var wasOpen = null;
    var closeTimer = null;
    var fadeTimer = null;

    function endClosing() {
      clearTimeout(closeTimer);
      html.classList.remove('kosz-closing');
    }

    drawer.addEventListener('transitionend', function (evt) {
      if (evt.target !== drawer || drawer.classList.contains('drawer--is-open')) return;
      if (evt.propertyName === 'transform' || evt.propertyName === 'opacity') endClosing();
    });

    function sync() {
      var open = drawer.classList.contains('drawer--is-open');
      if (open === wasOpen) return;
      var first = wasOpen === null;
      wasOpen = open;
      if (open) {
        if (state.rememberOpener) state.rememberOpener();
        if (state.scrollSignal) state.scrollSignal();
        endClosing();
        clearTimeout(fadeTimer);
        html.classList.remove('kosz-fading');
        html.classList.add('kosz-open');
        pickQuote(drawer, state);
        updatePromo(drawer, state);
        updateFulfillment(drawer, state);
        return;
      }
      html.classList.remove('kosz-open');
      clearTimeout(state.ftTimer);
      clearInterval(state.promoTimer);
      if (first) return;
      if (state.returnFocus) state.returnFocus();
      var out = cssMs(drawer, '--kosz-dur-out', 240);
      if (reducedMotion()) out = cssMs(drawer, '--kosz-dur-micro', 160);
      html.classList.add('kosz-closing', 'kosz-fading');
      closeTimer = setTimeout(endClosing, out + 80);
      fadeTimer = setTimeout(function () { html.classList.remove('kosz-fading'); }, out + 80);
    }

    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateShipping(drawer, state) {
    var bar = drawer.querySelector('[data-kosz-fs]');
    if (!bar) {
      state.free = null;
      state.pct = 0;
      return;
    }
    var fill = bar.querySelector('[data-kosz-fs-fill]');
    var free = bar.getAttribute('data-free') === 'true';
    var pct = parseInt(bar.getAttribute('data-pct'), 10) || 0;
    var animate = state.free !== undefined && !reducedMotion() && state.pct !== pct;

    fill.style.setProperty('--kosz-flow-phase', -(performance.now() % 2500) + 'ms');
    fill.style.transition = 'none';
    fill.style.width = (animate ? state.pct : pct) + '%';
    void fill.offsetWidth;
    fill.style.transition = '';
    if (animate) {
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    }

    if (typeof state.free === 'boolean' && state.free !== free && !reducedMotion()) {
      bar.classList.add('is-instant');
      bar.classList.toggle('is-free', state.free);
      void bar.offsetWidth;
      bar.classList.remove('is-instant');
      requestAnimationFrame(function () { bar.classList.toggle('is-free', free); });
    }

    if (free && state.free === false && !reducedMotion()) {
      bar.classList.add('is-celebrating');
    }
    var text = bar.querySelector('.kosz-fs__text');
    var said = text ? text.textContent.replace(/\s+/g, ' ').trim() : '';
    if (state.fsText !== undefined && said !== state.fsText && drawer.classList.contains('drawer--is-open')) {
      announce(drawer, said);
    }
    state.fsText = said;
    state.free = free;
    state.pct = pct;
  }

  var FT_CUTOFF = 12;
  var FT_URGENCY_MIN = 60;
  var FT_EXCLUDED = [
    '2025-01-01', '2025-01-06', '2025-04-20', '2025-04-21',
    '2025-05-01', '2025-05-03', '2025-06-08', '2025-06-19',
    '2025-08-15', '2025-11-01', '2025-11-11', '2025-12-25', '2025-12-26',
    '2026-01-01', '2026-01-06', '2026-04-05', '2026-04-06',
    '2026-05-01', '2026-05-03', '2026-05-24', '2026-06-04',
    '2026-08-15', '2026-11-01', '2026-11-11', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-01-06', '2027-03-28', '2027-03-29',
    '2027-05-01', '2027-05-03', '2027-05-16', '2027-05-27',
    '2027-08-15', '2027-11-01', '2027-11-11', '2027-12-25', '2027-12-26',
    '2028-01-01', '2028-01-06', '2028-04-16', '2028-04-17',
    '2028-05-01', '2028-05-03', '2028-06-04', '2028-06-15',
    '2028-08-15', '2028-11-01', '2028-11-11', '2028-12-25', '2028-12-26'
  ];

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function isWorkday(d) {
    var dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    var key = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    return FT_EXCLUDED.indexOf(key) === -1;
  }

  function nextWorkday(from) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    do { d.setDate(d.getDate() + 1); } while (!isWorkday(d));
    return d;
  }

  function relDay(now, target, t) {
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var tgt = new Date(target.getFullYear(), target.getMonth(), target.getDate());
    var diff = Math.round((tgt - today) / 86400000);
    if (diff === 0) return t.today;
    if (diff === 1) return t.tomorrow;
    if (diff === 2) return t.afterTomorrow;
    return t.onDay
      .replace('[weekday]', t.weekdays.split(',')[target.getDay()])
      .replace('[date]', target.getDate() + '.' + (target.getMonth() + 1));
  }

  function fmtCountdown(ms) {
    var sec = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    if (h > 0) return h + ':' + pad(m) + ':' + pad(s);
    return m + ':' + pad(s);
  }

  function fulfillmentText(days, t) {
    var out = { label: '', sub: '', urgent: false, tick: 0 };
    if (t.lang !== 'pl' || days > 1) {
      if (days <= 1) out.label = t.ready;
      else if (days <= 3) out.label = t.ships.replace('[days]', days);
      else if (days <= 14) out.label = t.fulfil.replace('[days]', days);
      else out.label = t.fulfilMax.replace('[days]', days);
      return out;
    }

    var now = new Date();
    var h = now.getHours();
    var m = now.getMinutes();
    out.label = t.ready;
    out.tick = 60000;

    if (isWorkday(now) && h < FT_CUTOFF) {
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), FT_CUTOFF, 0, 0);
      var minutesLeft = (FT_CUTOFF * 60) - (h * 60 + m);
      var arrival = relDay(now, nextWorkday(now), t);
      out.urgent = minutesLeft <= FT_URGENCY_MIN;
      out.sub = (out.urgent ? t.orderUrgent : t.order)
        .replace('[time]', fmtCountdown(cutoff - now))
        .replace('[day]', arrival);
      out.tick = 1000;
    } else {
      var shipDay = nextWorkday(now);
      out.sub = t.shipOn
        .replace('[ship]', relDay(now, shipDay, t))
        .replace('[day]', relDay(now, nextWorkday(shipDay), t));
    }
    return out;
  }

  function updateFulfillment(drawer, state) {
    var line = drawer.querySelector('[data-kosz-ft-line]');
    if (!line) return;
    clearTimeout(state.ftTimer);
    var carrier = drawer.querySelector('[data-products] [data-kosz-ft]');
    if (!carrier || drawer.classList.contains('is-empty')) {
      line.hidden = true;
      return;
    }
    var d = line.dataset;
    var text = fulfillmentText(parseInt(carrier.getAttribute('data-kosz-ft'), 10), {
      lang: d.lang, ready: d.ready, ships: d.ships, fulfil: d.fulfil, fulfilMax: d.fulfilMax,
      order: d.order, orderUrgent: d.orderUrgent, shipOn: d.shipOn, today: d.today,
      tomorrow: d.tomorrow, afterTomorrow: d.afterTomorrow, onDay: d.onDay, weekdays: d.weekdays
    });
    line.querySelector('[data-kosz-ft-label]').textContent = text.label;
    var sub = line.querySelector('[data-kosz-ft-sub]');
    sub.textContent = text.sub;
    sub.hidden = !text.sub;
    line.classList.toggle('is-urgent', text.urgent);
    line.hidden = false;
    if (text.tick && drawer.classList.contains('drawer--is-open')) {
      state.ftTimer = setTimeout(function () { updateFulfillment(drawer, state); }, text.tick);
    }
  }

  function updateTotal(drawer) {
    var target = drawer.querySelector('[data-kosz-total]');
    var source = drawer.querySelector('[data-subtotal]');
    if (target && source) target.textContent = source.textContent.trim();
  }

  function itemSignatures(root) {
    var map = {};
    if (!root || !root.querySelectorAll) return map;
    root.querySelectorAll('.cart__item[data-key]').forEach(function (el) {
      var qty = el.querySelector('.js-qty__num');
      map[el.getAttribute('data-key')] = el.textContent.replace(/\s+/g, ' ') + '|' + (qty ? qty.getAttribute('value') : '');
    });
    return map;
  }

  function markFresh(products, records) {
    var old = {};
    records.forEach(function (rec) {
      rec.removedNodes.forEach(function (node) {
        var sig = itemSignatures(node);
        Object.keys(sig).forEach(function (k) { old[k] = sig[k]; });
      });
    });
    var current = itemSignatures(products);
    Object.keys(current).forEach(function (key) {
      if (old[key] === current[key]) return;
      var el = products.querySelector('.cart__item[data-key="' + key + '"]');
      if (el) el.classList.add('kosz-fresh');
    });
  }

  function watchCart(drawer, state) {
    var products = drawer.querySelector('[data-products]');
    if (!products) return;
    var renders = 0;
    function rendered(records) {
      if (renders++ > 0 && records) markFresh(products, records);
      if (state.scrollSignal) state.scrollSignal();
      updateShipping(drawer, state);
      updateTotal(drawer);
      updateFulfillment(drawer, state);
    }
    new MutationObserver(rendered).observe(products, { childList: true });
    if (products.children.length) rendered();
  }

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function collapse(item) {
    return new Promise(function (resolve) {
      if (reducedMotion()) {
        item.hidden = true;
        resolve();
        return;
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }
      item.style.height = item.offsetHeight + 'px';
      void item.offsetHeight;
      item.classList.add('is-leaving');
      item.style.height = '0px';
      item.style.marginBottom = '0px';
      item.addEventListener('transitionend', function (evt) {
        if (evt.target === item && evt.propertyName === 'height') finish();
      });
      setTimeout(finish, cssMs(item, '--kosz-dur-out', 240) + 80);
    });
  }

  function removeItem(item, key) {
    if (!window.theme || !theme.cart || !theme.cart.changeItem || item.classList.contains('is-leaving')) return;
    var request = theme.cart.changeItem(key, 0).then(function (text) { return JSON.parse(text); });
    Promise.all([request, collapse(item)])
      .then(function (res) { rebuild(res[0]); })
      .catch(function () {
        item.classList.remove('is-leaving');
        item.hidden = false;
        item.style.height = '';
        item.style.marginBottom = '';
      });
  }

  function bindRemove(drawer) {
    drawer.addEventListener('click', function (evt) {
      var link = evt.target.closest('.cart__remove a[data-key]');
      if (!link) return;
      var item = link.closest('.cart__item');
      if (!item || !window.theme || !theme.cart || !theme.cart.changeItem) return;
      evt.preventDefault();
      removeItem(item, link.getAttribute('data-key'));
    });

    drawer.addEventListener('click', function (evt) {
      var minus = evt.target.closest('.js-qty__adjust--minus');
      if (!minus) return;
      var item = minus.closest('.cart__item');
      var input = item && item.querySelector('.js-qty__num');
      if (!input || parseInt(input.value, 10) > 1) return;
      evt.preventDefault();
      evt.stopPropagation();
      removeItem(item, item.getAttribute('data-key'));
    }, true);
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function postDiscount(codes) {
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('discount ' + r.status);
      return r.json();
    });
  }

  function appliedCodes() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; });
      });
  }

  function sameCode(a, b) {
    return a.toLowerCase() === b.toLowerCase();
  }

  function scroller(drawer) {
    return drawer.querySelector('.drawer__inner > .drawer__scrollable');
  }

  function reveal(drawer, el, done) {
    var box = scroller(drawer);
    if (!box) {
      if (done) done();
      return;
    }
    var view = box.getBoundingClientRect();
    var rect = el.getBoundingClientRect();
    var gap = 16;
    var delta = 0;
    if (rect.bottom + gap > view.bottom) delta = rect.bottom + gap - view.bottom;
    if (rect.top - delta < view.top + gap) delta = rect.top - view.top - gap;
    var target = Math.max(0, Math.min(box.scrollHeight - box.clientHeight, box.scrollTop + delta));
    if (Math.abs(target - box.scrollTop) < 1) {
      if (done) done();
      return;
    }
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      box.removeEventListener('scrollend', finish);
      if (done) done();
    }
    box.addEventListener('scrollend', finish);
    setTimeout(finish, reducedMotion() ? 0 : 600);
    box.scrollTo({ top: target, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  function watchScroll(drawer) {
    var box = scroller(drawer);
    if (!box) return function () {};
    var frame = null;
    function measure() {
      frame = null;
      var more = box.clientHeight > 0 && box.scrollHeight - box.scrollTop - box.clientHeight > 1;
      drawer.classList.toggle('has-more', more);
    }
    function schedule() {
      if (frame === null) frame = requestAnimationFrame(measure);
    }
    box.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      ro.observe(box);
      [].forEach.call(box.children, function (child) { ro.observe(child); });
    }
    return schedule;
  }

  function bindCode(drawer) {
    var box = drawer.querySelector('[data-kosz-code]');
    if (!box) return;
    var toggle = box.querySelector('[data-kosz-code-toggle]');
    var form = box.querySelector('.kosz-code__form');
    var input = box.querySelector('[data-kosz-code-input]');
    var apply = box.querySelector('[data-kosz-code-apply]');
    var msg = box.querySelector('[data-kosz-code-msg]');

    function say(text) {
      msg.textContent = text || '';
      msg.hidden = !text;
      input.setAttribute('aria-invalid', text ? 'true' : 'false');
      if (text) reveal(drawer, box);
    }

    function busy(on) {
      apply.disabled = on;
      box.classList.toggle('is-loading', on);
    }

    function submit() {
      var code = input.value.trim().slice(0, CODE_MAX);
      if (!code || apply.disabled) return;
      busy(true);
      say('');
      var kept;
      appliedCodes()
        .then(function (codes) {
          kept = codes.filter(function (c) { return !sameCode(c, code); });
          return postDiscount(kept.concat(code));
        })
        .then(function (cart) {
          var entry = (cart.discount_codes || []).filter(function (d) { return sameCode(d.code, code); })[0];
          if (entry && entry.applicable) {
            input.value = '';
            form.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            rebuild(cart);
            return null;
          }
          say(box.getAttribute('data-invalid'));
          return postDiscount(kept).then(rebuild);
        })
        .catch(function () { say(box.getAttribute('data-error')); })
        .then(function () { busy(false); });
    }

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      form.hidden = !open;
      if (open) reveal(drawer, box, function () { input.focus({ preventScroll: true }); });
    });

    apply.addEventListener('click', submit);
    input.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        submit();
      }
    });
    input.addEventListener('input', function () { say(''); });

    drawer.addEventListener('click', function (evt) {
      var remove = evt.target.closest('[data-kosz-code-remove]');
      if (!remove) return;
      var code = remove.getAttribute('data-kosz-code-remove');
      remove.disabled = true;
      appliedCodes()
        .then(function (codes) {
          return postDiscount(codes.filter(function (c) { return !sameCode(c, code); }));
        })
        .then(rebuild)
        .catch(function () {
          remove.disabled = false;
          say(box.getAttribute('data-error'));
        });
    });
  }

  function chatElement() {
    var chat = document.querySelector('shopify-chat');
    return chat && typeof chat.show === 'function' ? chat : null;
  }

  function bindChat(drawer) {
    var watched = null;

    function watchChat(chat) {
      if (watched === chat) return;
      watched = chat;
      new MutationObserver(function () {
        if (!chat.hasAttribute('open')) html.classList.remove('kosz-chat');
      }).observe(chat, { attributes: true, attributeFilter: ['open'] });
      chat.addEventListener('click', function (evt) {
        if (html.classList.contains('kosz-open')) evt.stopPropagation();
      });
    }

    drawer.addEventListener('click', function (evt) {
      var trigger = evt.target.closest('[data-kosz-chat]');
      if (!trigger) return;
      var chat = chatElement();
      if (!chat) return;
      evt.preventDefault();
      evt.stopPropagation();
      watchChat(chat);
      html.classList.add('kosz-chat');
      chat.show();
    });
  }

  function init() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.hasAttribute('data-kosz-ready')) return;
    drawer.setAttribute('data-kosz-ready', '');
    var state = { free: undefined, pct: 0, ftTimer: null, quote: null, promoTimer: null };
    state.scrollSignal = watchScroll(drawer);
    bindFocus(drawer, state);
    watchOpen(drawer, state);
    watchCart(drawer, state);
    bindRemove(drawer);
    bindChat(drawer);
    bindCode(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
